export default __webpack_public_path__ + "static/media/offer-price-bg.403538ef.png";